
<template>
    <elecBoardPackage></elecBoardPackage>
  </template>
    
  <script>
  import elecBoardPackage from "@/components/elecBoard/elecBoardPackage";
  export default {
    components: {
      elecBoardPackage,
    },
    setup() {},
  };
  </script>
    
  <style lang="scss"></style>
    